export default __webpack_public_path__ + "static/media/bubble_age_5.b05284b0.svg";